import { useRef } from 'react'

// A re-keyed report reaches the list a moment before the page points at its new id. Through that
// window the panels keep the report they last resolved, rather than throwing and being unmounted,
// which would also stop the generation polls they own.
const useCurrentReport = (reports, reportId) => {
  const lastReport = useRef()

  const found = (reports || []).find(item => item.id == reportId)
  if (found) lastReport.current = found

  return found ?? lastReport.current
}

export default useCurrentReport
